import ReservationStore  from "./reservation.store";
import WidgetStore from "./widget.store";

export const stores = {
  reservationStore: ReservationStore,
  widgetStore: WidgetStore
};
